import { useEffect, useState } from 'react';
import { listJobTypes, type JobType } from '../../../../reference-data/reference-data.api';

/** The job-type select for filters and line forms: active only, fetched once (a small fixed catalogue, so no server paging). */
export function useJobTypeOptions(): JobType[] {
  const [jobTypes, setJobTypes] = useState<JobType[]>([]);

  useEffect(() => {
    let cancelled = false;
    listJobTypes()
      .then((all) => {
        if (!cancelled) setJobTypes(all.filter((type) => type.isActive));
      })
      .catch(() => {
        if (!cancelled) setJobTypes([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return jobTypes;
}
